"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayHideButton = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
// this is temporary while work on EN-3049 is in progress
// when EN-3049 is complete, files in the v2 folder will replace the existing side-bar files
const sidebar_section_styles_1 = require("../sidebar-section.styles");
const DisplayHideButton = ({ isDisplayed, toggleDisplay, }) => (react_1.default.createElement(sidebar_section_styles_1.StyledIconButton, { onClick: toggleDisplay }, react_1.default.createElement(ui_components_1.Icon, { variant: isDisplayed ? 'chevronDown' : 'chevronRight', color: ui_components_1.baseColors.primaryGreen300 })));
exports.DisplayHideButton = DisplayHideButton;
exports.default = exports.DisplayHideButton;
